
import { ButtonHeading, CityDropdownForTrip, CommonDateRange, CommonInput, CustomPagination, CustomSelect } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import Tab from 'components/common/Tab';
import { constant } from 'constants'
import { utils } from 'helper';
import moment from 'moment';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { StorageServices } from 'utils';
import { AiOutlineEye, AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsChevronDown, BsThreeDotsVertical } from "react-icons/bs";
import { FaRegTrashCan } from "react-icons/fa6";
import { FiEdit, FiPrinter } from "react-icons/fi";
import { getServiceList } from '_services/workShopServices/workShopServices';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { deleteTransactionApi, getAllVehicleNumber, venderDropdownApi } from '_services';
import StorageService from 'utils/StorageServices';
import toast from 'react-hot-toast';
import { ConfirmModalFor, MakePaymentOfServiceModal, PaymentVoucher, VoucherReport } from 'modals';
import { getMoneyInListApi, getMoneyOutListApi, getVoucherReport } from '_services/accountingServices/accountingServices';
import { UserContext } from 'context';
import { Images } from "constants";

const MoneyIn = () => {

    const ITEMS_PER_PAGE = 20
    const DEBOUNCE_DELAY = 500;
    const isResetting = useRef(false);
    const isInitialMount = useRef(true);
    const initailFilter = {
        company_id: StorageServices.getCompanyId(),
        limit: ITEMS_PER_PAGE,
        offset: 1,
        start_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("month").format("YYYY-MM-DD"),
        relation_type: 0,
        search: "",
    }
    const { masterData } = useContext(UserContext)
    const navigate = useNavigate();
    const [totalItems, setTotalItems] = useState(0);
    const [resetKey, setResetKey] = useState(0);
    const [searchInput, setSearchInput] = useState("");
    const [moneyInList, setMoneyInList] = useState([])
    const [filter, setFilter] = useState(initailFilter)
    const [selectedRange, setSelectedRange] = useState({
        startDate: "",
        endDate: "",
    });
    const [confirmModalShow, setConfirmModalShow] = useState(false);
    const [isOpenMakePayment, setIsOpenMakePayment] = useState(false)
    const [paymentVoucherOpen, setPaymentVoucherOpen] = useState(false);
    const [voucherReportShow, setVoucherReportShow] = useState(false)
    const [printLoadingId, setPrintLoadingId] = useState(null);
 const [deleteLoading, setDeleteLoading] = useState(false);

    useEffect(() => {
        getServiceHandle()
    }, [filter])


    useEffect(() => {
        if (isResetting.current) {
            isResetting.current = false;
            return;
        }

        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        const delayTimer = setTimeout(() => {
            setFilter((prev) => ({
                ...prev,
                search: searchInput,
                offset: 1,
            }));
            return () => clearTimeout(delayTimer);
        }, DEBOUNCE_DELAY);

        return () => clearTimeout(delayTimer);
    }, [searchInput]);

    const getServiceHandle = async () => {
        const payload = {
            ...filter,
        }

        try {
            const res = await getMoneyInListApi(payload)
            if (res?.responseCode === 200) {
                setMoneyInList(res?.data?.list)
                setTotalItems(res?.data?.total_record)
            }
        } catch (error) {

        } finally {

        }

    }

    const addServiceFunction = (e) => {
        navigate('/WorkshopServicing/AddService')
        // setShow(true)
    }




    const columns = [
        { header: "Date of Payment", accessor: "date" },
        { header: "Voucher", accessor: "voucher" },
        { header: "Relation", accessor: "relation" },
        { header: "Sys Reference", accessor: "tripdetails" },
        { header: "Vendor", accessor: "vendor_detail" },
        { header: "From Account", accessor: "fromAccount" },
        { header: "Amount", accessor: "total_amount" },
        { header: "Action", accessor: "actionButton" },
    ];


    const rowListData = (data) => {
        return data?.map((item, i) => {

            const vendorRoutes = {
                4: (id) => `/account/vendors/details/${id}?tab=2`,
                3: (id) => `/account/driver/details/${id}`,
                1: (id) => `/account/supplier/details/${id}?tab=4`,
                2: (id) => `/account/consignor/details/${id}?tab=4`,
            };

            return {
                ...item,

                date: (
                    <React.Fragment>
                        {item?.date
                            ? utils?.formateDateCalander(item?.date)
                            : "-"}
                    </React.Fragment>
                ),
                vendor_detail: (
                    <React.Fragment>
                        {
                            item?.vendor_detail?.name ?
                                <div>
                                    <div className="">
                                        {item?.vendor_type ? masterData?.vendor_type[item?.vendor_type] : ""}
                                    </div>
                                    <Link to={vendorRoutes[item?.vendor_type]?.(item?.vendor_detail?._id)} style={{ textDecoration: 'none' }} state={item?.vendor_type === 3 ? { data: { driver: "own", type: 2, name: item?.vendor_detail?.name } } : {}}>
                                        {/* onClick={() => navigate(vendorRoutes[item?.vendor_type]?.(item?.vendor_detail?._id) || "")} */}
                                        {item?.vendor_detail?.name ? item?.vendor_detail?.name : "-"}
                                    </Link>
                                </div>
                                :
                                <div className="" >
                                    No Vendor
                                </div>
                        }
                    </React.Fragment >
                ),
                vehicle: (
                    <React.Fragment>
                        <div className="imgSel_box">
                            {item?.vehicle
                                ? item.vehicle?.vehicle_no
                                : "-"}
                        </div>
                    </React.Fragment>
                ),
                sub_total: (
                    <React.Fragment>
                        <div className="imgSel_box">
                            {item?.total_amount ? `₹ ${item?.total_amount.toFixed(2)}` : "₹ 0.00"}
                        </div>
                    </React.Fragment>
                ),
                total_amount: (
                    <React.Fragment>
                        <div className="imgSel_box">
                            {item?.total_amount ? `₹ ${item?.total_amount.toFixed(2)}` : "₹ 0.00"}
                        </div>
                    </React.Fragment>
                ),
                voucher: (
                    <div
                        className="imgSel_box"
                        onClick={(e) => {
                            e.stopPropagation(); // यह uncomment करें और div पर लगाएं
                            setVoucherReportShow(item?._id);
                        }}
                        style={{ cursor: 'pointer' }} // यह भी add करें
                    >
                        {`#${item?.voucher_no}` || "-"}
                    </div>
                ),

                relation: (
                    <React.Fragment>
                        <div className="imgSel_box">
                            {item?.sub_type_name ? item?.sub_type_name : item?.type_name}
                        </div>
                    </React.Fragment>
                ),
                tripdetails: (
                    <div className="">
                        {(item?.trip?.trip_number && item?.trip?._id) ?

                            <Link to={`/trip/addtrip/dispatched/${item?.trip?._id}`}>{`#${item?.trip?.trip_number || ""}`}</Link>
                            : <> - </>}
                    </div>


                ),
                service_status: (
                    <React.Fragment>
                        <div className="imgSel_box" style={{ fontSize: "14px", color: "#0FCA5A", fontWeight: 400 }}>
                            {item?.payment_status}
                        </div>
                    </React.Fragment>
                ),
                fromAccount: (
                    <React.Fragment>
                        <div className="imgSel_box" style={{ fontSize: "14px", fontWeight: 400 }}>
                            {item?.payment_mode?.name ? `${item?.payment_mode?.name} > ${item?.payment_mode?.account?.name}` : "-"}
                        </div>
                    </React.Fragment>
                ),
                actionButton: (
                    <div
                        className="_anvSwitcherNew form-check form-switch"
                        style={{ width: "100px" }}
                    >

                        {/* {masterChildBranch?.edit === 1 && */}
                        <div
                            onClick={(e) => {
                                e.stopPropagation(); // यह uncomment करें और div पर लगाएं
                                if (!printLoadingId) handlePrintDownload(item?._id);
                            }}
                            className='_avPointer'
                            style={{ textAlign: "center" }}
                        >
                            {printLoadingId === item?._id ? (
                                <AiOutlineLoading3Quarters
                                    className="spinLoader"
                                    size={20}
                                    style={{ color: "#3f51b5" }}
                                />
                            ) : (
                                <FiPrinter color='#3f51b5' size={20} />
                            )}
                        </div>
                        {/* } */}

                        {/* {masterChildBranch?.delete === 1 &&  */}
                        <div
                            onClick={(e) => {
                                e.stopPropagation();
                                setConfirmModalShow(item?.transaction_id);
                            }}

                            className='_avPointer'
                        >
                            <span className='_samAnchor'>
                                <span className='deleteIcon_avt'>
                                    <FaRegTrashCan color='red' />
                                </span>

                            </span>
                        </div>
                        {/* } */}
                    </div>
                ),
            };
        });
    };


    const handlePrintDownload = async (voucherId) => {
        try {
            setPrintLoadingId(voucherId);

            const res = await getVoucherReport({
                company_id: StorageService?.getCompanyId(),
                voucher_id: voucherId
            });

            let html = res;

            // Replace title for custom PDF file name
            html = html.replace(
                /<title>.*<\/title>/,
                `<title>Bilty-${voucherId}</title>`
            );

            // Add print styles for single page A5 landscape
            const printStyles = `
               <style>
                   @page {
                       size: A5 landscape;
                       margin: 0;
                   }
                   
                   @media print {
                       * {
                           page-break-before: avoid !important;
                           page-break-after: avoid !important;
                           page-break-inside: avoid !important;
                       }
                       
                       html, body {
                           margin: 0 !important;
                           padding: 0 !important;
                           width: 210mm !important;
                           height: 148mm !important;
                           overflow: hidden !important;
                       }
                       
                       body {
                           -webkit-print-color-adjust: exact;
                           print-color-adjust: exact;
                           padding: 10mm;
                           box-sizing: border-box;
                       }
                       
                       /* Prevent page breaks */
                       table, div, section, article {
                           page-break-inside: avoid !important;
                       }
                   }
               </style>
           `;

            // Insert styles before closing </head> tag or at the beginning
            if (html.includes('</head>')) {
                html = html.replace('</head>', `${printStyles}</head>`);
            } else {
                html = printStyles + html;
            }

            const iframe = document.createElement("iframe");
            iframe.style.position = "absolute";
            iframe.style.width = "0";
            iframe.style.height = "0";
            iframe.style.border = "0";
            iframe.style.visibility = "hidden";

            document.body.appendChild(iframe);

            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write(html);
            doc.close();

            setTimeout(() => {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();

                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 2000);
            }, 500);

            setPrintLoadingId(false);
        } catch (err) {
            console.error("Print error:", err);
            setPrintLoadingId(false);
        }
    };

    const handleApply = (newRange) => {
        setSelectedRange(newRange);
        setFilter((prev) => ({
            ...prev,
            start_date: moment(newRange.startDate).format("YYYY-MM-DD"),
            end_date: moment(newRange.endDate).format("YYYY-MM-DD"),
            offset: 1,
        }));
    };

    const handleReset = () => {
        isResetting.current = true;
        setFilter(initailFilter);
        setSearchInput("")
        setSelectedRange({
            startDate: '',
            endDate: '',
        })
    };

    const handlePageChange = (page) => {
        setFilter((prev) => ({ ...prev, offset: page }));
    };

    const callBackFreight = () => {
        getServiceHandle()
    }

    const handleDelete = async () => {
        const payload = {
            company_id: StorageService?.getCompanyId(),
            transaction_id: confirmModalShow,
        };
        try {
            setDeleteLoading(true);
            const res = await deleteTransactionApi(payload);
            if (res?.responseCode == 200) {
                toast.success(res?.responseMessage);
                setConfirmModalShow(false);
                getServiceHandle()
                setDeleteLoading(false);
            } else {
                setDeleteLoading(false);
                // toast.error(res?.responseMessage);
            }
        } catch (error) {
            setDeleteLoading(false);

        }
    };

    let confirmModalProps = {
        show: confirmModalShow,
        closeModal: (e) => {
            setConfirmModalShow(false);
        },
        title: "Confirm",
        submitTitle: "Delete",
        onSubmit: handleDelete,
        confirmModal: "confirmModal",
        icon: Images.DELETEICON.default,
        isLoadding: deleteLoading,
        disabled: deleteLoading,
    };


    const isDisabled =
        !searchInput &&
        !filter?.start_date;

    const makePaymentProps = {
        isOpen: isOpenMakePayment,
        closeModal: () => setIsOpenMakePayment(false),
        headerPart: false,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _lgModal",
        modalTitle: "Make Payment",
        submitTitle: "Save",
        callBackFreight: callBackFreight,

    }

    const paymentVoucherProps = {
        paymentVoucherOpen: paymentVoucherOpen,
        closeModal: () => setPaymentVoucherOpen(false),
        voucherId: paymentVoucherOpen?._id,
        oprnDeleteModal: setConfirmModalShow
    };

    let voucherReoprtProps = {
        isOpen: voucherReportShow,
        closeModal: (e) => setVoucherReportShow(false),
        modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
        footerPart: true,
        modalTitle: "Voucher Report",
        voucherId: voucherReportShow,
    }

    return (
        <>
            <div className='addPr_flBx __wrkShpSrvcng'>
                <ButtonHeading
                    title={"Payments"}
                    onClick={() => { }}
                    buttonTitle={"Make Payment"}

                />
                <>
                    <div className='pr_procssBx' id="addPartyContent" style={{ margin: '0px' }}>
                        <div className='pr_procssBx_grid'>

                            <div>
                                <CommonDateRange
                                    key={resetKey}
                                    initialStartDate={selectedRange.startDate || ""}
                                    initialEndDate={selectedRange.endDate || ""}
                                    datePrefield={!!(selectedRange.startDate && selectedRange.endDate)}
                                    onApply={handleApply}
                                />
                            </div>

                            <div style={{ flex: '0 0 220px' }}>
                                <CommonInput
                                    placeholder="Search "
                                    label="Search "
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                />
                            </div>
                            <button
                                className="anime-btn __reSet_btn"
                                disabled={isDisabled}
                                onClick={handleReset}
                                style={{
                                    backgroundColor: isDisabled ? "#ccc" : "",
                                    color: isDisabled ? "#666" : "white",
                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                    border: "none",
                                    padding: "8px 16px",
                                    borderRadius: "6px",
                                    transition: "all 0.3s ease",
                                }}
                            >
                                Reset
                            </button>

                        </div>
                    </div>

                    {/* Table Section */}
                    <div className="_tabWith_outTab">
                        <BootstrapTable
                            tableClass="companyTable_bx"
                            columns={columns}
                            data={rowListData(moneyInList?.length > 0 ? moneyInList : [])}
                        />
                        <div className="paginationFt_avt">
                            <CustomPagination
                                totalItems={totalItems || 1}
                                itemsPerPage={ITEMS_PER_PAGE}
                                currentPage={filter.offset}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </>
                {paymentVoucherOpen && <PaymentVoucher {...paymentVoucherProps} />}
                {voucherReportShow
                    && (
                        <VoucherReport {...voucherReoprtProps} />
                    )
                }

                {/* {isOpenMakePayment && <MakePaymentOfServiceModal {...makePaymentProps}/>} */}
                {confirmModalShow && (
                    <ConfirmModalFor {...confirmModalProps}>
                        <>
                            <p className="_confirmPrx">
                                {" "}
                                Are you sure you want to delete " {"Transaction"} "{" "}
                            </p>
                        </>
                    </ConfirmModalFor>
                )}
            </div>
        </>
    )
}

export default MoneyIn